import {Directive, Input, numberAttribute} from '@angular/core';
import {AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors} from '@angular/forms';
import {Observable, of} from 'rxjs';
import {debounceTime, first, map} from 'rxjs/operators';

@Directive({
    selector: '[nlrForbiddenValues]',
    standalone: true,
    providers: [{provide: NG_ASYNC_VALIDATORS, useExisting: NlrForbiddenValuesDirective, multi: true}]
})
export class NlrForbiddenValuesDirective implements AsyncValidator {
    @Input()
    nlrForbiddenValues: string[];

    @Input({transform: numberAttribute})
    nlrForbiddenValuesDebounceTime: number = 750;

    constructor() {}

    validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
        // When valid, return immediately
        if (!this.nlrForbiddenValues.some(v => v === control.value || `${v}` === `${control.value}`)) {
            return of(null);
        }

        // When invalid, validate again after debounce time has elapsed
        return control.valueChanges.pipe(
            debounceTime(this.nlrForbiddenValuesDebounceTime),
            map(() => (this.isForbidden(control) ? {nlrForbiddenValues: true} : null)),
            first()
        );
    }

    private isForbidden(control: AbstractControl) {
        return this.nlrForbiddenValues.some(v => v === control.value || `${v}` === `${control.value}`);
    }
}
